export default function ErrorFallback({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert">
      <h2>Something went wrong</h2>
      <pre>{error.message}</pre>

      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}
